import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = {
  key: 0,
  style: {"height":"60vh","display":"grid","grid-template-columns":"repeat(2, 1fr)","grid-gap":"1.5rem"}
}
const _hoisted_5 = { style: {"height":"60vh"} }
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = {
  class: "p-field-label",
  for: "risename"
}
const _hoisted_8 = {
  for: "risename",
  class: "fs-13 label-error"
}
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = { class: "p-field-label mb-3" }
const _hoisted_11 = { style: {"height":"60vh"} }
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = {
  class: "p-field-label mt-1",
  for: "interfaceAddr"
}
const _hoisted_14 = {
  for: "interfaceAddr",
  class: "fs-13 label-error"
}
const _hoisted_15 = { class: "p-field mt-0 mb-4" }
const _hoisted_16 = { class: "p-field-label mb-2" }
const _hoisted_17 = {
  key: 0,
  class: "separator mt-3 mb-4",
  style: {"background-color":"currentColor","opacity":"0.25"}
}
const _hoisted_18 = {
  key: 1,
  style: {"height":"60vh","display":"grid","grid-template-columns":"0.9fr 1.1fr","grid-gap":"1rem"}
}
const _hoisted_19 = { style: {"height":"60vh","border-right":"1px solid rgba(0, 0, 0, 0.08)","padding-right":"1rem"} }
const _hoisted_20 = { class: "p-field d-flex align-items-center mb-3" }
const _hoisted_21 = { class: "p-field-label mb-0" }
const _hoisted_22 = { class: "ml-auto" }
const _hoisted_23 = { class: "p-field-label" }
const _hoisted_24 = { style: {"height":"60vh"} }
const _hoisted_25 = { class: "text-gray mb-2" }
const _hoisted_26 = { class: "ml-auto" }
const _hoisted_27 = { class: "text-uppercase text-gray small" }
const _hoisted_28 = { class: "dialog-custom__footer" }
const _hoisted_29 = {
  key: 0,
  class: "form-custom mr-auto"
}
const _hoisted_30 = { class: "p-field-label" }
const _hoisted_31 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_32 = { class: "label-error fs-13" }
const _hoisted_33 = {
  key: 1,
  class: "form-custom mr-auto"
}
const _hoisted_34 = { class: "p-field-label" }
const _hoisted_35 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_36 = { class: "label-error fs-13" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_ListItemRadio = _resolveComponent("ListItemRadio")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_NumberButtons = _resolveComponent("NumberButtons")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isDialogVisible = $event)),
    onHide: _ctx.doHideDialog,
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom",
    style: {"width":"calc(100% - 2rem)","max-width":"80vw"}
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      _createVNode("div", _hoisted_3, [
        (!_ctx.isBrfa || _ctx.brfaStep === 0)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_ElScrollbar, { style: {"margin":"0 -10px 0 -20px","padding":"0 20px"} }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("AppResourceEP.Name")), 1),
                      _createVNode(_component_InputText, {
                        id: "risename",
                        type: "text",
                        class: ["w-100", { 'input-error': !_ctx.isValidName }],
                        modelValue: _ctx.riser.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.riser.name = $event))
                      }, null, 8, ["modelValue", "class"]),
                      _createVNode("label", _hoisted_8, _toDisplayString(_ctx.invalidNameReason), 1)
                    ]),
                    _createVNode("div", _hoisted_9, [
                      _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("AppResourceEP.RiserInterfaceModeUpper")), 1),
                      _createVNode(_component_ListItemRadio, {
                        disabled: !_ctx.isNewRiser && _ctx.numOfTotalApartments > 100,
                        label: _ctx.$t('AppResourceEP.Mode5IndependentRiser'),
                        inputId: "InterfaceComboMode_Mode5IndipendentRiser",
                        modelValue: _ctx.interfaceComboMode,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.interfaceComboMode = $event)),
                        name: "riserInterfaceMode",
                        value: _ctx.RiserInterfaceModeCombo.Mode5IndipendentRiser
                      }, null, 8, ["disabled", "label", "modelValue", "value"]),
                      _createVNode(_component_ListItemRadio, {
                        disabled: !_ctx.isNewRiser && _ctx.numOfTotalApartments > 200,
                        label: _ctx.$t('AppResourceEP.Mode6ExtendedRiserAndOneMode7ExtendedRiserExpansion'),
                        inputId: "InterfaceComboMode_Mode6ExtendedRiserAndOneMode7ExtendedRiserExpansion",
                        modelValue: _ctx.interfaceComboMode,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.interfaceComboMode = $event)),
                        name: "riserInterfaceMode",
                        value: _ctx.RiserInterfaceModeCombo.Mode6ExtendedRiserAndOneMode7ExtendedRiserExpansion
                      }, null, 8, ["disabled", "label", "modelValue", "value"]),
                      _createVNode(_component_ListItemRadio, {
                        label: _ctx.$t('AppResourceEP.Mode6ExtendedRiserAndTwoMode7ExtendedRiserExpansion'),
                        inputId: "InterfaceComboMode_Mode6ExtendedRiserAndTwoMode7ExtendedRiserExpansion",
                        modelValue: _ctx.interfaceComboMode,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.interfaceComboMode = $event)),
                        name: "riserInterfaceMode",
                        value: _ctx.RiserInterfaceModeCombo.Mode6ExtendedRiserAndTwoMode7ExtendedRiserExpansion,
                        last: ""
                      }, null, 8, ["label", "modelValue", "value"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_ElScrollbar, { style: {"margin":"0 -20px","padding":"0 20px"} }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentRiserInterfaces, (riserInterface, key) => {
                      return (_openBlock(), _createBlock(_Fragment, { key: key }, [
                        _createVNode("div", _hoisted_12, [
                          _createVNode("h6", null, _toDisplayString(_ctx.getInterfaceDescription(riserInterface.mode, key, _ctx.currentRiserInterfaces.length)), 1),
                          _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("AppResourceEP.RiserInterfaceAddressMUpper")), 1),
                          (key === 0)
                            ? (_openBlock(), _createBlock(_component_InputText, {
                                key: 0,
                                id: "interfaceAddr",
                                class: {'input-error': _ctx.anyScsError},
                                type: "number",
                                min: _ctx.MIN_SCS_ADDRESS_INTERFACE,
                                max: _ctx.MAX_SCS_ADDRESS_INTERFACE,
                                style: {"width":"60%"},
                                modelValue: _ctx.mainScsAddress,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.mainScsAddress = $event))
                              }, null, 8, ["class", "min", "max", "modelValue"]))
                            : (_openBlock(), _createBlock(_component_InputText, {
                                key: 1,
                                disabled: "",
                                id: "interfaceAddr",
                                class: {'input-error': _ctx.addrNotValid[key]},
                                type: "number",
                                style: {"width":"60%"},
                                modelValue: riserInterface.scsAddress,
                                "onUpdate:modelValue": ($event: any) => (riserInterface.scsAddress = $event)
                              }, null, 8, ["class", "modelValue", "onUpdate:modelValue"])),
                          _createVNode("div", null, [
                            _createVNode("label", _hoisted_14, _toDisplayString(_ctx.invalidAddrReason[key]), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_15, [
                          _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("AppResourceEP.NumberOfApartmentsUpper")) + ": ", 1),
                          _createVNode(_component_Dropdown, {
                            class: "w-100",
                            modelValue: riserInterface.numberOfApartments,
                            "onUpdate:modelValue": ($event: any) => (riserInterface.numberOfApartments = $event),
                            options: _ctx.noAppartmentOptions(),
                            optionLabel: "label",
                            optionValue: "value"
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                        ]),
                        (key !== (_ctx.currentRiserInterfaces.length - 1))
                          ? (_openBlock(), _createBlock("hr", _hoisted_17))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isBrfa && _ctx.brfaStep === 1)
          ? (_openBlock(), _createBlock("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode(_component_ElScrollbar, { style: {"margin":"0 -10px 0 -20px","padding":"0 20px"} }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_20, [
                      _createVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('AppResourceEP.Floors')), 1),
                      _createVNode("div", _hoisted_22, [
                        _createVNode(_component_NumberButtons, {
                          modelValue: _ctx.floorsCount,
                          minValue: 1,
                          disableDecrease: !_ctx.isNewRiser || _ctx.floorsCount <= 1,
                          disableIncrement: !_ctx.isNewRiser,
                          onIncrement: _ctx.addFloorDistribution,
                          onDecrement: _cache[6] || (_cache[6] = ($event: any) => (_ctx.removeFloorDistribution(_ctx.floorsCount - 1)))
                        }, null, 8, ["modelValue", "disableDecrease", "disableIncrement", "onIncrement"])
                      ])
                    ]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.riserFloorDistribution, (floor, floorIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        key: floor.id,
                        class: "p-field mb-3"
                      }, [
                        _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('AppResourceEP.Floor')) + " " + _toDisplayString(floorIndex + 1), 1),
                        _createVNode(_component_InputText, {
                          class: "w-100",
                          modelValue: floor.name,
                          "onUpdate:modelValue": ($event: any) => (floor.name = $event),
                          disabled: !_ctx.isNewRiser
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_24, [
                _createVNode(_component_ElScrollbar, { style: {"margin":"0 -20px","padding":"0 20px"} }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.riserFloorDistribution, (floor) => {
                      return (_openBlock(), _createBlock("div", {
                        key: `${floor.id}_distribution`,
                        class: "mb-3 d-flex"
                      }, [
                        _createVNode("div", _hoisted_25, _toDisplayString(floor.name), 1),
                        _createVNode("div", _hoisted_26, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(floor.apartmentDistribution, (distribution, idx) => {
                            return (_openBlock(), _createBlock("div", {
                              key: `${floor.id}_${distribution.interfaceId}`,
                              class: "mb-2 d-flex flex-column"
                            }, [
                              _createVNode("label", _hoisted_27, _toDisplayString(_ctx.getInterfaceDescription(_ctx.currentRiserInterfaces[idx]?.mode, idx, _ctx.currentRiserInterfaces.length)), 1),
                              _createVNode(_component_Dropdown, {
                                options: _ctx.apartmentCountValues(distribution.interfaceId, floor.id),
                                optionLabel: "label",
                                optionValue: "value",
                                optionDisabled: "disabled",
                                modelValue: distribution.count,
                                onChange: ($event: any) => (_ctx.onDistributionChange(distribution, $event))
                              }, null, 8, ["options", "modelValue", "onChange"])
                            ]))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("footer", _hoisted_28, [
        (_ctx.isBrfa && _ctx.brfaStep === 1 && _ctx.floorDistributionHasError)
          ? (_openBlock(), _createBlock("span", _hoisted_29, [
              _createVNode("span", _hoisted_30, [
                _createVNode("label", null, _toDisplayString(_ctx.$t('AppResourceEP.SetupWizardStepBuidingLinkApartemntsTitle')), 1),
                _hoisted_31,
                _createVNode("label", _hoisted_32, _toDisplayString(_ctx.floorDistributionErrorText.join(' | ')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.errorWithApartmentNumber)
          ? (_openBlock(), _createBlock("span", _hoisted_33, [
              _createVNode("span", _hoisted_34, [
                _createVNode("label", null, _toDisplayString(_ctx.mismatchedApartmentsErrorText[0]), 1),
                _hoisted_35,
                _createVNode("label", _hoisted_36, _toDisplayString(_ctx.mismatchedApartmentsErrorText[1]), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          onClick: _ctx.handleSecondaryButtonAction
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.secondaryButtonLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: _ctx.buttonSubmitLabel,
          onClick: _ctx.handleButtonSubmitAction,
          class: "p-button-rounded p-button-raised p-button--m",
          disabled: _ctx.saveButtonDisabled
        }, null, 8, ["label", "onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}